export const getAreGigapixelsLoading = (state) => state.bentleyModel.areGigapixelsLoading
export const getBentleyImagesList = (state) => state.bentleyModel.imagesList
export const getUpcomingGigapixels = (state) => state.bentleyModel.contentGigapixels?.UpcomingGigapixels
export const getUsedGigapixels = (state) => state.bentleyModel.contentGigapixels?.UsedGigapixels
